module.exports = __webpack_public_path__ + "img/leveler-4-on.aae1fd5e.png";